/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export class ResponsiveNavCodes {
  public static NAV_LEVEL_1: number = 1;
  public static NAV_LEVEL_2: number = 2;
  public static NAV_CLOSE_ALL: string = 'NAV_CLOSE_ALL';
  public static NAV_OPEN: string = 'NAV_OPEN';
  public static NAV_CLOSE: string = 'NAV_CLOSE';
  public static NAV_TOGGLE: string = 'NAV_TOGGLE';
  public static NAV_CLASS_HAMBURGER_MENU: string = 'open-hamburger-menu';
  public static NAV_CLASS_OVERFLOW_MENU: string = 'open-overflow-menu';
  public static NAV_CLASS_TRIGGER_1: string = 'header-hamburger-trigger';
  public static NAV_CLASS_TRIGGER_2: string = 'header-overflow-trigger';
  public static NAV_CLASS_LEVEL_1: string = 'clr-nav-level-1';
  public static NAV_CLASS_LEVEL_2: string = 'clr-nav-level-2';
}
